import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../FirebaseConfig"; // Firebase authentication configuration
import { useNavigate } from "react-router-dom";
import login_background from "./login_background.jpg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false); // Snackbar visibility state
  const navigate = useNavigate();

  const handlePasswordReset = async () => {
    if (!email) {
      setError("Email is required.");
      setOpenSnackbar(true);
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccessMessage("Password reset link sent to your email.");
      setOpenSnackbar(true);
      setTimeout(() => navigate("/login"), 3000); // Redirect to login after success
    } catch (err) {
      console.error(err);
      setError("Failed to send reset email. Please try again.");
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Grid container>
      {/* Side Image Section */}
      <Grid
        item
        xs={12}
        sm={6}
        sx={{
          backgroundColor: "#f7f7f7",
          display: { xs: "none", sm: "flex" },
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={login_background}
          alt="Forgot Password"
          sx={{ maxWidth: "100%" }}
        />
      </Grid>

      {/* Forgot Password Form Section */}
      <Grid
        item
        xs={12}
        sm={6}
        sx={{
          padding: 4,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Box sx={{ maxWidth: 400, width: "100%" }}>
          <Typography variant="h4" sx={{ mb: 2, color: "#7D4AEA", fontWeight: "bold" }}>
            Forgot Password
          </Typography>
          <Typography sx={{ mb: 3, color: "#757575" }}>
            Enter your registered email address to receive a password reset link.
          </Typography>

          <TextField
            fullWidth
            variant="outlined"
            label="Email"
            type="email"
            value={email}
            sx={{ mb: 2 }}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "#7D4AEA",
              color: "#fff",
              "&:hover": { backgroundColor: "#643AB0" },
            }}
            onClick={handlePasswordReset}
          >
            Send Reset Link
          </Button>

          <Button
            fullWidth
            variant="text"
            sx={{ mt: 2, textTransform: "none", color: "#7D4AEA" }}
            onClick={() => navigate("/")}
          >
            Back to Login
          </Button>
        </Box>
      </Grid>

      {/* Snackbar for Error or Success Messages */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={error ? "error" : "success"}
          variant="filled"
          onClose={handleCloseSnackbar}
          sx={{ width: "100%" }}
        >
          {error || successMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default ForgotPassword;
